import React, { useContext } from 'react';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import Container from 'ls-common-client/dist/components/Container';
import { Context } from '../../context/AppContext';
import LifestyleBlogs from '../../components/Blogs/Lifestyle';
import LayoutContainer from '../../components/LayoutContainer';
import Header from '../../components/Header';
import GertieGhost from '../../components/GertieGhost';
import { MODALS } from '../../constants';

const StyledRoot = styled(Container)`
  background: #ffffff;
  .Header--search {
    max-width: 400px;
  }
  + .Footer__root {
    display: none;
  }
`;

const StyledContent = styled(Container)`
  height: calc(100vh - 495px);
  margin: auto;
  display: flex;
  min-height: 500px;
  align-items: center;
  justify-content: center;
  h1 {
    font-size: 48px;
    font-family: 'Circular';
    font-weight: bold;
    line-height: 64px;
    margin-bottom: 28px;
  }
  p {
    color: ${props => props.theme.text.text300};
    font-size: 18px;
    line-height: 24px;
    margin-bottom: 56px;
    max-width: 470px;
  }
  button {
    border-radius: 28px;
    border: solid 1px ${props => props.theme.primary.normal};
    background-color: #ffffff;
    color: #5570f9;
    cursor: pointer;
    display: inline-block;
    padding: 11px 22px;
    font-size: 18px;
    transition: all 0.3s ease;
    -webkit-tap-highlight-color: rgba(85, 112, 249, 1);
    &:hover {
      color: ${props => props.theme.primary.normal};
      outline: 0;
      text-decoration: none;
      border: solid 1px ${props => props.theme.primary.normal};
      background-color: #eaefff;
    }
  }

  @media ${props => props.theme.mediaQueries.tablet} {
    max-width: 800px;

    h1 {
      font-size: 32px;
      line-height: 36px;
    }
    p {
      font-size: 18px;
      line-height: 24px;
    }
    button {
      padding: 6px 22px;
      font-size: 16px;
    }
  }
  @media ${props => props.theme.mediaQueries.mobile} {
    max-width: 800px;
    flex-direction: column-reverse;
    h1 {
      font-size: 32px;
      line-height: 36px;
    }
    p {
      font-size: 18px;
      line-height: 24px;
    }
    button {
      padding: 6px 22px;
      font-size: 16px;
    }
  }

  @media (max-width: 767px) and (orientation: landscape) {
    flex-direction: row;
  }

  @media screen and (max-width: 480px) {
    h1 {
      font-size: 20px;
      line-height: 25px;
      margin-bottom: 18px;
    }
    h1 span {
      display: block;
    }
    p {
      font-size: 12px;
      line-height: 18px;
      margin-bottom: 22px;
    }
  }
`;

const StyledStatus = styled(Container)`
  color: ${props => props.theme.text.text300};
  font-size: 18px;
`;

const StyledLeft = styled(Container)`
  flex: 1;
  @media ${props => props.theme.mediaQueries.mobile} {
    padding-bottom: 20px;
  }

  @media (max-width: 767px) and (orientation: landscape) {
    h1 {
      font-size: 20px;
    }
    p {
      font-size: 16px;
      line-height: 22px;
    }
  }
`;

const StyledRight = styled(Container)`
  min-width: 40%;
  align-items: center;
  position: relative;
  img {
    max-height: 330px;
  }

  @media ${props => props.theme.mediaQueries.tablet} {
    flex: 1;
    display: flex;
  }

  @media (max-width: 767px) {
    flex: 1;
    display: flex;
  }

  @media (max-width: 767px) and (orientation: landscape) {
    max-width: 200px;
    min-width: 200px;

    img {
      max-width: 200px;
    }
  }
  @media screen and (max-width: 480px) {
    img {
      max-width: 300px;
    }
  }
`;

const NotFound = () => {
  const {
    modal: { showModal },
    media: { mobile, tablet },
  } = useContext(Context);
  let gertieWidth;
  let gertieHeight;

  if (mobile) {
    gertieWidth = 250;
    gertieHeight = 250;
  } else if (tablet) {
    gertieWidth = 350;
    gertieHeight = 350;
  } else {
    gertieWidth = 450;
    gertieHeight = 450;
  }

  const openSearch = () => {
    showModal(MODALS.SEARCH_AUTOSUGGEST);
  };

  return (
    <StyledRoot>
      <Helmet>
        <title>Page not found</title>
      </Helmet>
      <Header is404 />
      <LayoutContainer>
        <StyledContent>
          <StyledLeft>
            <StyledStatus>404</StyledStatus>
            <h1>
              <span>Look, you found Gertie</span> the ghost
            </h1>
            <p>
              Unless you are a ghost hunter, you were probably looking for a
              business near you and not our spooky friend.
            </p>
            <button onClick={openSearch}>Start a New Search</button>
          </StyledLeft>
          <StyledRight>
            <GertieGhost width={gertieWidth} height={gertieHeight} />
          </StyledRight>
        </StyledContent>
      </LayoutContainer>
      <LifestyleBlogs />
    </StyledRoot>
  );
};

export default NotFound;
